var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCountryUs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2858_8476)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.895431 0.895431 0 2 0H26C27.1046 0 28 0.895431 28 2V18C28 19.1046 27.1046 20 26 20H2C0.895431 20 0 19.1046 0 18V2Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2858_8476",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.895431 0.895431 0 2 0H26C27.1046 0 28 0.895431 28 2V18C28 19.1046 27.1046 20 26 20H2C0.895431 20 0 19.1046 0 18V2Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2858_8476)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 0H0V1.33333H28V0ZM28 2.66667H0V4H28V2.66667ZM0 5.33333H28V6.66667H0V5.33333ZM28 8H0V9.33333H28V8ZM0 10.6667H28V12H0V10.6667ZM28 13.3333H0V14.6667H28V13.3333ZM0 16H28V17.3333H0V16ZM28 18.6667H0V20H28V18.6667Z",
    fill: "#D02F44"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 9.33333,
    fill: "#46467F"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2858_8476)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.66659 2.00004C2.66659 2.36823 2.36811 2.66671 1.99992 2.66671C1.63173 2.66671 1.33325 2.36823 1.33325 2.00004C1.33325 1.63185 1.63173 1.33337 1.99992 1.33337C2.36811 1.33337 2.66659 1.63185 2.66659 2.00004ZM5.33325 2.00004C5.33325 2.36823 5.03478 2.66671 4.66659 2.66671C4.2984 2.66671 3.99992 2.36823 3.99992 2.00004C3.99992 1.63185 4.2984 1.33337 4.66659 1.33337C5.03478 1.33337 5.33325 1.63185 5.33325 2.00004ZM7.33325 2.66671C7.70144 2.66671 7.99992 2.36823 7.99992 2.00004C7.99992 1.63185 7.70144 1.33337 7.33325 1.33337C6.96506 1.33337 6.66659 1.63185 6.66659 2.00004C6.66659 2.36823 6.96506 2.66671 7.33325 2.66671ZM10.6666 2.00004C10.6666 2.36823 10.3681 2.66671 9.99992 2.66671C9.63173 2.66671 9.33325 2.36823 9.33325 2.00004C9.33325 1.63185 9.63173 1.33337 9.99992 1.33337C10.3681 1.33337 10.6666 1.63185 10.6666 2.00004ZM3.33325 4.00004C3.70144 4.00004 3.99992 3.70156 3.99992 3.33337C3.99992 2.96518 3.70144 2.66671 3.33325 2.66671C2.96506 2.66671 2.66659 2.96518 2.66659 3.33337C2.66659 3.70156 2.96506 4.00004 3.33325 4.00004ZM6.66659 3.33337C6.66659 3.70156 6.36811 4.00004 5.99992 4.00004C5.63173 4.00004 5.33325 3.70156 5.33325 3.33337C5.33325 2.96518 5.63173 2.66671 5.99992 2.66671C6.36811 2.66671 6.66659 2.96518 6.66659 3.33337ZM8.66658 4.00004C9.03477 4.00004 9.33325 3.70156 9.33325 3.33337C9.33325 2.96518 9.03477 2.66671 8.66658 2.66671C8.2984 2.66671 7.99992 2.96518 7.99992 3.33337C7.99992 3.70156 8.2984 4.00004 8.66658 4.00004ZM10.6666 4.66671C10.6666 5.0349 10.3681 5.33337 9.99992 5.33337C9.63173 5.33337 9.33325 5.0349 9.33325 4.66671C9.33325 4.29852 9.63173 4.00004 9.99992 4.00004C10.3681 4.00004 10.6666 4.29852 10.6666 4.66671ZM7.33325 5.33337C7.70144 5.33337 7.99992 5.0349 7.99992 4.66671C7.99992 4.29852 7.70144 4.00004 7.33325 4.00004C6.96506 4.00004 6.66659 4.29852 6.66659 4.66671C6.66659 5.0349 6.96506 5.33337 7.33325 5.33337ZM5.33325 4.66671C5.33325 5.0349 5.03478 5.33337 4.66659 5.33337C4.2984 5.33337 3.99992 5.0349 3.99992 4.66671C3.99992 4.29852 4.2984 4.00004 4.66659 4.00004C5.03478 4.00004 5.33325 4.29852 5.33325 4.66671ZM1.99992 5.33337C2.36811 5.33337 2.66659 5.0349 2.66659 4.66671C2.66659 4.29852 2.36811 4.00004 1.99992 4.00004C1.63173 4.00004 1.33325 4.29852 1.33325 4.66671C1.33325 5.0349 1.63173 5.33337 1.99992 5.33337ZM3.99992 6.00004C3.99992 6.36823 3.70144 6.66671 3.33325 6.66671C2.96506 6.66671 2.66659 6.36823 2.66659 6.00004C2.66659 5.63185 2.96506 5.33337 3.33325 5.33337C3.70144 5.33337 3.99992 5.63185 3.99992 6.00004ZM5.99992 6.66671C6.36811 6.66671 6.66659 6.36823 6.66659 6.00004C6.66659 5.63185 6.36811 5.33337 5.99992 5.33337C5.63173 5.33337 5.33325 5.63185 5.33325 6.00004C5.33325 6.36823 5.63173 6.66671 5.99992 6.66671ZM9.33325 6.00004C9.33325 6.36823 9.03477 6.66671 8.66658 6.66671C8.2984 6.66671 7.99992 6.36823 7.99992 6.00004C7.99992 5.63185 8.2984 5.33337 8.66658 5.33337C9.03477 5.33337 9.33325 5.63185 9.33325 6.00004ZM9.99992 8.00004C10.3681 8.00004 10.6666 7.70156 10.6666 7.33337C10.6666 6.96518 10.3681 6.66671 9.99992 6.66671C9.63173 6.66671 9.33325 6.96518 9.33325 7.33337C9.33325 7.70156 9.63173 8.00004 9.99992 8.00004ZM7.99992 7.33337C7.99992 7.70156 7.70144 8.00004 7.33325 8.00004C6.96506 8.00004 6.66659 7.70156 6.66659 7.33337C6.66659 6.96518 6.96506 6.66671 7.33325 6.66671C7.70144 6.66671 7.99992 6.96518 7.99992 7.33337ZM4.66659 8.00004C5.03478 8.00004 5.33325 7.70156 5.33325 7.33337C5.33325 6.96518 5.03478 6.66671 4.66659 6.66671C4.2984 6.66671 3.99992 6.96518 3.99992 7.33337C3.99992 7.70156 4.2984 8.00004 4.66659 8.00004ZM2.66659 7.33337C2.66659 7.70156 2.36811 8.00004 1.99992 8.00004C1.63173 8.00004 1.33325 7.70156 1.33325 7.33337C1.33325 6.96518 1.63173 6.66671 1.99992 6.66671C2.36811 6.66671 2.66659 6.96518 2.66659 7.33337Z",
    fill: "url(#paint0_linear_2858_8476)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2858_8476",
    x: 1.33325,
    y: 1.33337,
    width: 9.33325,
    height: 7.66663,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2858_8476"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2858_8476",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2858_8476",
    x1: 1.33325,
    y1: 1.33337,
    x2: 1.33325,
    y2: 8.00004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2858_8476"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.895431 0.895431 0 2 0H26C27.1046 0 28 0.895431 28 2V18C28 19.1046 27.1046 20 26 20H2C0.895431 20 0 19.1046 0 18V2Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountryUs);
export default __webpack_public_path__ + "static/media/Country=US.155e89cd7bf63fc4d4192921a2860d05.svg";
export { ForwardRef as ReactComponent };